'use client';
import { useEffect } from 'react';

import { useTranslation } from '@/lib/i18n/i18n.client';
import LottieAnimation from '@/lib/lottie';
import { useApi } from '@/hooks/useApi';

import Heading from '@/components/atoms/heading';
import LinkButton from '@/components/atoms/linkButton';

import { assetPrefix } from '@/constant/config';
import HeadingDC from '@/decodo/components/atoms/Heading';
import LinkButtonDC from '@/decodo/components/atoms/LinkButton';

export default function ErrorPageContent({ message }: { message?: string }) {
  const { data, makeApiCall } = useApi<string>({
    url: `${assetPrefix}/animations/404.json`,
  });
  const { texts } = useTranslation();

  const isDecodo =
    process.env.NEXT_PUBLIC_COMPONENT_VARIANT?.includes('decodo');

  useEffect(() => {
    makeApiCall();
  }, []);

  return (
    <main>
      <section className='layout bg-base-white flex min-h-screen flex-col items-center justify-center p-9 text-center text-black'>
        <div className='flex aspect-video w-full max-w-[753px]'>
          {data && (
            <LottieAnimation
              animationData={data}
              loop={true}
              className='w-full'
            />
          )}
        </div>
        {isDecodo ? (
          <HeadingDC level='h3'>
            {message ?? texts.error_page.oops_not_found}
          </HeadingDC>
        ) : (
          <Heading level='h3'>
            {message ?? texts.error_page.oops_not_found}
          </Heading>
        )}
        <div className='mt-6'>
          {isDecodo ? (
            <LinkButtonDC variant='filled' color='primary' href='/'>
              {texts.error_page.back_to_home}
            </LinkButtonDC>
          ) : (
            <LinkButton variant='filled' color='primary' href='/'>
              {texts.error_page.back_to_home}
            </LinkButton>
          )}
        </div>
      </section>
    </main>
  );
}
